import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../styles/testimony.css";

const testimonials = [
    { text: "I had a really great experience here! The massage itself was super relaxing and professional — exactly what I needed. The front desk staff were also very welcoming and helpful, especially Jasmine. She was so cooperative and made the whole process smooth from start to finish. Definitely recommend their services if you’re looking for both quality treatments and amazing customer care!", author: "Shumaila R.", rating: 5 },
    { text: "Came here with my family and we all loved it! The place is really clean and welcoming. Miko and Jasmine at the reception were super sweet and helpful. Penny, Grace and Linda did such a great job with the massages – we felt so relaxed after. Definitely recommend!", author: "W Oaoki.", rating: 5 },
    { text: "Absolutely fantastic experience at Cedarwood Spa& Wellness! The atmosphere was serene and welcoming, and the staff were incredibly professional and attentive. The treatments were top-notch and left me feeling completely rejuvenated. Highly recommend for anyone looking to relax and unwind. Five stars all the way!", author: "Hao P.", rating: 5 },
    { text: "Visiting this place is always such a relief for my body. Penny is highly professional and never fails to heal my back pain issues during each session. Jasmine is incredibly welcoming and always makes us feel special.", author: "Raj M.", rating: 4 },
    { text: "Just had an amazing massage at Cedarwood! The staff Jasmine was super friendly and made me feel right at home. The massage was incredibly relaxing and exactly what I needed. The spa is clean and has a really calming vibe. Highly recommend! Definitely coming back!!!", author: "Yiting W.", rating: 5 },
    { text: "Very comfortable environment with professional massage therapist 💗 we have been here couple times and feel very relieved after coming! :)", author: "Phoebe C.", rating: 5 },
];

const Testimony: React.FC = () => {
    const [index, setIndex] = useState(0);
    const [itemsToShow, setItemsToShow] = useState(3); // default desktop

    // ✅ Detect screen size
    useEffect(() => {
        const updateItems = () => {
            setItemsToShow(window.innerWidth <= 768 ? 1 : 3);
        };
        updateItems();
        window.addEventListener("resize", updateItems);
        return () => window.removeEventListener("resize", updateItems);
    }, []);

    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % testimonials.length);
    };

    const prevSlide = () => {
        setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    };

    // ✅ Show correct number of cards
    const visibleTestimonials = Array.from({ length: itemsToShow }, (_, i) =>
        testimonials[(index + i) % testimonials.length]
    );

    return (
        <section id="testimony" className="testimony-section">
            <h2 className="section-title">What Our Clients Say</h2>
            <hr className="fancy-hr" />
            <div className="carousel">
                <button className="carousel-btn left" onClick={prevSlide}>
                    <FaChevronLeft />
                </button>
                <div className="carousel-track">
                    {visibleTestimonials.map((t, i) => (
                        <div className="testimonial" key={i}>
                            <span className="quote">“</span>
                            <p>{t.text}</p>
                            <span className="quote">”</span>
                            <div className="rating">
                                {Array.from({ length: t.rating }, (_, idx) => (
                                    <span key={idx} className="filled-star">⭐</span>
                                ))}
                            </div>
                            <h4>- {t.author}</h4>
                        </div>
                    ))}
                </div>
                <button className="carousel-btn right" onClick={nextSlide}>
                    <FaChevronRight />
                </button>
            </div>
        </section>
    );
};

export default Testimony;
